// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"19a123ee","39":"57a32f78","87":"071a8c52","387":"6a3c7bfa","855":"7eb22c41","987":"30451616"}[chunkId] + ".css";
};